import React, { useState, useEffect, useRef } from "react";
import {
  Chat,
  Channel,
  ChannelHeader,
  MessageList,
  MessageInput,
  Window,
  Thread,
  LoadingIndicator,
} from "stream-chat-react";
import { StreamChat } from "stream-chat";
import "stream-chat-react/dist/css/v2/index.css";
import { getChat } from "./../Api";
import "../css/Chat.css";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { FaPaperPlane } from "react-icons/fa";
import { GoPlusCircle } from "react-icons/go";
import { FaFile } from "react-icons/fa";
import secureLocalStorage from "react-secure-storage";

const apiKey = "689zge653a2x";

const getPatientId = () => secureLocalStorage.getItem("patient_id");

const getPatientInfo = () => secureLocalStorage.getItem("patient_info");

const userId = getPatientId();

const user = {
  id: String(userId),
  name:
    userId === getPatientId() ? getPatientInfo()?.patient_name : "Patient Test",
};

let otherUser = "325";

const Chats = () => {
  const [chatHistory, setChatHistory] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [typingMessage, setTypingMessage] = useState("");
  const [activeChannelId, setActiveChannelId] = useState(null);
  const chatBoxRef = useRef(null);
  const bottomRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [messageInputValue, setMessageInputValue] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const messageInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [chatClient, setChatClient] = useState(null);
  const [channel, setChannel] = useState(null);
  const [streamChatHistory, setStreamChatHistory] = useState([]);
  const [userChannels, setUserChannels] = useState([]);

  const messageSets = [
    [
      "Recovery takes time—so does getting you the best answer!",
      "Checking this against your journey…",
      "Hang tight...",
      "Almost there…",
      "Here we go!",
    ],
    [
      "Every step counts—including this one!",
      "Lining this up with your journey…",
      "Hold on, double-checking…",
      "Almost ready…",
      "I got this!",
    ],
    [
      "Knees need patience—so do great answers!",
      "Piecing this together just for you…",
      "Hang tight, almost there…",
      "A few more seconds…",
      "And voilà!",
    ],
    [
      "I've got you—let's make this count!",
      "Tailoring this to your recovery…",
      "Just about ready…",
      "Hang tight!",
      "Here it is!",
    ],
    [
      "Your recovery, your pace—let's do this right!",
      "Aligning this with your personal goals…",
      "Fine-tuning for you…",
      "Locking in the best insights!",
      "All set!",
    ],
  ];

  const formatMessage = (message) => {
    return message.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
  };

  const handleSendMessage = async () => {
    if (chatInput.trim() === "") return;
    const userMessage = { role: "user", content: chatInput };
    setChatHistory((prev) => [...prev, userMessage]);
    setIsTyping(true);
    setChatInput("");

    const selectedSet =
      messageSets[Math.floor(Math.random() * messageSets.length)];
    let messageIndex = 0;
    const lastMessageIndex = selectedSet.length - 1;

    function updateLoadingMessage() {
      if (messageIndex < lastMessageIndex) {
        setTypingMessage(selectedSet[messageIndex]);
        messageIndex++;

        const randomInterval = Math.random() * 1500 + 3000;
        setTimeout(updateLoadingMessage, randomInterval);
      }
    }

    updateLoadingMessage();

    try {
      const response = await getChat({
        topic: chatInput,
        patientId: getPatientId(),
        history: [...chatHistory, userMessage],
        personality: "NURSE_PERSONALITY",
      });
      const janeMessage = {
        role: "jane",
        content: response.message.replace(/\n/g, "<br />"),
      };
      setChatHistory((prev) => [...prev, janeMessage]);
    } catch (error) {
      console.error("Error fetching chat response:", error);
    } finally {
      setIsTyping(false);
    }
  };

  useEffect(() => {
    document.body.classList.add("chat");

    return () => {
      document.body.classList.remove("chat");
    };
  }, []);

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [chatHistory, isTyping]);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatHistory, isTyping]);

  const handleAddChatClick = async () => {
    if (["325", "331", "332", "333"].includes(user.id)) {
      const name = prompt("Enter Patient ID");
      if (name) {
        const existingChannel = userChannels.find((ch) =>
          Object.values(ch.state.members).some((member) => member.user.id === name)
        );

        let newChannel;
        if (!existingChannel) {
          newChannel = chatClient.channel("messaging", {
            name: `Chat with ${name}`,
            members: [user.id, name],
          });

          await newChannel.watch();
          setUserChannels((prev) => [newChannel, ...prev]);
          setChannel(newChannel);
        } else {
          setChannel(existingChannel);
        }

        setActiveChannelId(existingChannel ? existingChannel.id : newChannel.id);
        console.log("Patient name entered:", name);
      }
    }
    // else{
    //   alert('Coming soon!');
    // }
  };

  useEffect(() => {
    const initChat = async () => {
      const client = StreamChat.getInstance(apiKey);
      const devToken = client.devToken(user.id);
      try {
        await client.connectUser(user, devToken);

        if (user.id !== "325") {
          const uniqueChannelId = [user.id, otherUser].sort().join("-");
          const channel = client.channel("messaging", uniqueChannelId, {
            name: `Chat with ${otherUser}`,
            members: [user.id, otherUser],
          });

          await channel.watch();
          setChannel(channel);
        }

        setChatClient(client);

        const channels = await client.queryChannels({ members: { $in: [user.id] } });
        setUserChannels(channels);
        console.log(channels);

        channels.forEach((ch) => {
          ch.on("message.new", (event) => {
            if (event.message.user.id !== user.id) {
              setStreamChatHistory((prev) => [event.message, ...prev]);
              const existingChannelIndex = userChannels.findIndex(
                (channel) => channel.id === event.channel.id
              );

              if (existingChannelIndex !== -1) {
                const updatedChannels = [...userChannels];
                const [existingChannel] = updatedChannels.splice(existingChannelIndex, 1);
                updatedChannels.unshift(existingChannel);
                setUserChannels(updatedChannels);
              }
            }
          });
        });
      } catch (err) {
        console.error("Stream setup failed:", err);
      }
    };
    initChat();

    return () => {
      if (chatClient) chatClient.disconnectUser();
    };
  }, []);

  const addEmoji = (emoji) => {
    const textarea = messageInputRef.current;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const newValue =
        messageInputValue.slice(0, start) +
        emoji.native +
        messageInputValue.slice(end);
      setMessageInputValue(newValue);
      setTimeout(() => {
        textarea.setSelectionRange(
          start + emoji.native.length,
          start + emoji.native.length
        );
        textarea.focus();
      }, 0);
    }
  };

  const handleSendMessageToHuman = async () => {
    if (!messageInputValue.trim() && !selectedFile) return;

    const message = { text: messageInputValue };

    if (selectedFile) {
      try {
        let fileUpload;
        const isImage = selectedFile.type.startsWith("image/");

        if (isImage) {
          fileUpload = await channel.sendImage(selectedFile);
          message.attachments = [
            {
              type: "image",
              image_url: fileUpload.file,
              fallback: selectedFile.name,
            },
          ];
        } else {
          fileUpload = await channel.sendFile(selectedFile);
          message.attachments = [
            {
              type: "file",
              asset_url: fileUpload.file,
              title: selectedFile.name,
              file_size: selectedFile.size,
              mime_type: selectedFile.type,
            },
          ];
        }
      } catch (error) {
        console.error("File upload failed:", error);
      }

      setSelectedFile(null);
    }

    await channel.sendMessage(message);
    setMessageInputValue("");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setMessageInputValue("");
      setTimeout(() => handleSendMessageToHuman(), 0);
    }
  };

  const handleChannelClick = async (channel) => {
    setActiveChannelId(channel.id);
    setChannel(channel);
    const messages = await channel.query({ messages: { limit: 20 } });
    setStreamChatHistory(messages.messages.reverse());

    // Move the clicked channel to the top if there are unread messages
    if (channel.state.unreadCount > 0) {
      const updatedChannels = userChannels.filter((ch) => ch.id !== channel.id);
      updatedChannels.unshift(channel);
      setUserChannels(updatedChannels);
    }
  };

  return (
    <main className="main-content">
      <div className="chat-container">
        <div
          className="chat-sidebar"
          style={{ position: "fixed", top: 0, left: 0, height: "100vh" }}
        >
          <div className="chat-fixed">
            <div className="search-bar">
              <input
                type="text"
                className="search"
                placeholder="Search Messages"
              />
              <img
                className="add-chat"
                src="../addChat.svg"
                onClick={handleAddChatClick}
              />
            </div>

            <div className="conversation-with-jane">
              <div className="conversation-tab">
                <h5 className="conversation-heading">Talk to Jane</h5>
                <ul>
                  <li
                    className={`recipient ${activeChannelId === null ? "active" : ""}`}
                    onClick={() => setActiveChannelId(null)}
                  >
                    <div className="recipient-photo">
                      <img src="../ChatWithJane.svg" alt="Care Jane" />
                    </div>
                    <div className="recipient-details">
                      <div className="recipient-header">
                        <h3>Care Jane</h3>
                      </div>
                      <p className="last-chat">
                        {chatHistory.length > 0
                          ? `${
                              chatHistory[chatHistory.length - 1].role ===
                              "user"
                                ? "You"
                                : "Jane"
                            }: ${
                              chatHistory[chatHistory.length - 1].content.split(
                                "\n"
                              )[0]
                            }`
                          : "New Conversation"}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="conversation-with-human">
              <div className="conversation-tab">
                <h5 className="conversation-heading">Chats</h5>
                <ul>
                  {userChannels.map((channel) => {
                    const otherMember = Object.values(channel.state.members).find(
                      (member) => member.user.id !== user.id
                    );
                    const isActive = activeChannelId === channel.id;
                    return (
                      <li
                        key={channel.id}
                        className={`recipient ${isActive ? "active" : ""}`}
                        onClick={() => handleChannelClick(channel)}
                      >
                        <div className="recipient-photo">
                          <img
                            className="chat-avatar"
                            src={
                              otherMember.user.name === "Coach Mitch"
                                ? "/coach-mitch.png"
                                : otherMember.user.name === "Coach Ness"
                                ? "/coach-ness.png"
                                : otherMember.user.name === "Coach Rizza"
                                ? "/coach-rizza.png"
                                : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                    otherMember.user.name
                                  )}&background=random&color=fff`
                            }
                            alt={otherMember.user.name}
                          />
                        </div>
                        <div className={`recipient-details ${channel.countUnread() == 0 ? "read" : ""}`}>
                          <div className="recipient-header">
                            <h3>{otherMember.user.name}</h3>
                          </div>
                          <p className="last-chat">
                            {channel.countUnread() > 0
                              ? "New Message"
                              : channel.state.messages.length > 0
                              ? `${
                                  channel.state.messages[
                                    channel.state.messages.length - 1
                                  ].user.id === user.id
                                    ? "You"
                                    : channel.state.messages[
                                        channel.state.messages.length - 1
                                      ].user.name
                                }: ${
                                  channel.state.messages[
                                    channel.state.messages.length - 1
                                  ].text.split("\n")[0]
                                }`
                              : "New Conversation"}
                          </p>
                          {channel.countUnread() > 0 && (
                            <span className="notif-icon">
                              {channel.countUnread()}
                            </span>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          {activeChannelId === null ? (
            <div className="chat-with-jane">
              <input
                type="text"
                className="chat-field"
                placeholder="Chat with Care Jane"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                disabled={isTyping}
              />
              <a className="sendChat" onClick={handleSendMessage}>
                <img src="../sendChat.svg" alt="Send" />
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
        {activeChannelId !== null ? (
          <div className="chat-contents" style={{ marginLeft: "23%" }}>
            {chatClient && channel ? (
              <Chat client={chatClient} theme="messaging light">
                <div className="chat-header">
                  <div className="left">
                    <img
                      className="chat-avatar"
                      src={
                        Object.values(channel.state.members).find(
                          (member) => member.user.id !== user.id
                        )?.user.name === "Coach Mitch"
                          ? "/coach-mitch.png"
                          : Object.values(channel.state.members).find(
                              (member) => member.user.id !== user.id
                            )?.user.name === "Coach Ness"
                          ? "/coach-ness.png"
                          : Object.values(channel.state.members).find(
                              (member) => member.user.id !== user.id
                            )?.user.name === "Coach Rizza"
                          ? "/coach-rizza.png"
                          : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              Object.values(channel.state.members).find(
                                (member) => member.user.id !== user.id
                              )?.user.name || (channel.data.name ? channel.data.name : "New Conversation")
                            )}&background=random&color=fff`
                      }
                      alt={
                        Object.values(channel.state.members).find(
                          (member) => member.user.id !== user.id
                        )?.user.name || channel.data.name
                      }
                    />
                  </div>
                  <div className="right">
                    <h2>
                      {Object.values(channel.state.members).find(
                        (member) => member.user.id !== user.id
                      )?.user.name || channel.data.name}
                    </h2>
                    <h4>Online</h4>
                  </div>
                  <div className="divider"></div>
                </div>
                <div style={{ height: "100vh" }}>
                  <Channel channel={channel}>
                    <Window>
                      <MessageList />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "0 10px 10px 10px",
                          position: "relative",
                        }}
                      >
                        <button
                          onClick={() => fileInputRef.current.click()}
                          style={{
                            padding: "12px 0 8px 5px",
                            fontSize: "24px",
                            cursor: "pointer",
                            border: "none",
                            background: "transparent",
                            color: "#ccc",
                          }}
                          title="Attach file"
                        >
                          <GoPlusCircle />
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />

                        <button
                          onClick={() => setShowEmojiPicker((prev) => !prev)}
                          style={{
                            padding: "8px 0 8px 0",
                            fontSize: "24px",
                            cursor: "pointer",
                            border: "none",
                            background: "transparent",
                            color: "#fc6448",
                          }}
                          title="Insert emoji"
                        >
                          😀
                        </button>

                        <textarea
                          ref={messageInputRef}
                          value={messageInputValue}
                          onChange={(e) => setMessageInputValue(e.target.value)}
                          onFocus={() => setShowEmojiPicker(false)}
                          rows={1}
                          style={{
                            flex: 1,
                            resize: "none",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            fontSize: "24px",
                            fontFamily: "inherit",
                          }}
                        />

                        <button
                          onClick={handleSendMessageToHuman}
                          style={{
                            padding: "8px",
                            fontSize: "24px",
                            cursor: "pointer",
                            border: "none",
                            background: "transparent",
                            color: "#fc6448",
                          }}
                          title="Send message"
                        >
                          <FaPaperPlane />
                        </button>

                        {showEmojiPicker && (
                          <div
                            style={{
                              position: "absolute",
                              zIndex: 10,
                              bottom: "60px",
                              left: "40px",
                            }}
                          >
                            <Picker data={data} onEmojiSelect={addEmoji} />
                          </div>
                        )}
                      </div>

                      {selectedFile && (
                        <div
                          style={{ paddingLeft: "15px", marginBottom: "10px" }}
                        >
                          {selectedFile.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(selectedFile)}
                              alt="preview"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                borderRadius: "4px",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <FaFile
                              style={{ fontSize: "48px", color: "#ccc" }}
                            />
                          )}
                        </div>
                      )}
                    </Window>
                    <Thread />
                  </Channel>
                </div>
              </Chat>
            ) : (
              <LoadingIndicator />
            )}
          </div>
        ) : (
          <div className="chat-contents" style={{ marginLeft: "23%" }}>
            <div className="chat-header">
              <div className="left">
                <img src="../ChatWithJane.svg" alt="Care Jane" />
              </div>
              <div className="right">
                <h2>Care Jane</h2>
                <h4>Online</h4>
              </div>
              <div className="divider"></div>
            </div>
            <div className="chat-box" ref={chatBoxRef}>
              {chatHistory.map((message, index) => (
                <div
                  key={index}
                  className={`chat-bubble ${
                    message.role === "user" ? "user-bubble" : "jane-bubble"
                  }`}
                  style={{
                    animation: "slideUp 0.5s ease-out",
                    transformOrigin:
                      message.role === "user" ? "bottom right" : "bottom left",
                  }}
                >
                  <div>
                    {message.role === "jane" ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: formatMessage(message.content),
                        }}
                      />
                    ) : (
                      <p>{message.content}</p>
                    )}
                  </div>
                </div>
              ))}

              {isTyping && (
                <div
                  className="chat-bubble jane-bubble typing-indicator"
                  style={{
                    animation: "slideUp 0.5s ease-out",
                    transformOrigin: "bottom left",
                  }}
                >
                  <p>{typingMessage}</p>
                </div>
              )}
              <div ref={bottomRef} />
            </div>

            <div className="chat-with-jane mobile">
              <input
                type="text"
                className="chat-field"
                placeholder="Chat with Care Jane"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                disabled={isTyping}
              />
              <a className="sendChat" onClick={handleSendMessage}>
                <img src="../sendChat.svg" alt="Send" />
              </a>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default Chats;
